import { useController, UseControllerProps } from "react-hook-form";

interface InputProps {
  label?: string;
  placeholder?: string;
  rows?: number;
}

function Textarea<T extends FieldValues>(props: Props<T>) {
  const { field, fieldState } = useController<T>(props);
  return (
    <div className="form-input">
      {props.label && (
        <label className="form-input_label">
          {props.label}
          {props.rules && (
            <span className="form-input_label-required">&nbsp;*</span>
          )}
        </label>
      )}
      <textarea
        rows={props?.rows || 3}
        className={`p-2 form-input_field w-100 ${
          fieldState.error && "form-input_field-error"
        }`}
        placeholder={props.placeholder}
        {...field}
      />
      {fieldState.error && (
        <span className="form-input_error-message">
          {fieldState.error.message}
        </span>
      )}
    </div>
  );
}

export default Textarea;
